module.exports = __webpack_public_path__ + "img/telephone-and-internet.8f503b74.svg";